import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'
import stringComparator from 'utils/stringComparator'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const TicketTypeFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const ticketTypes = useAppSelector((state) => state.tickets.types) ?? []
  const sortedTicketTypes = [...ticketTypes].sort((a, b) => stringComparator(a.name, b.name))
  const data = sortedTicketTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Types'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
